import CirgsCustomerForm from './CirgsCustomerForm';

export default CirgsCustomerForm;
